import { NavigateFunction } from "react-router-dom"
import { Dispatch } from "redux"

import { login } from "api"
import {
  SIGNIN_FAILURE,
  AUTHENTICATION_CHECK_SUCCESS,
  AUTHENTICATION_CHECK_ERROR,
  SIGN_OUT_SUCCESS,
  SIGNIN_CALL,
  SIGNIN_SUCCESS
} from "./actions-types"

export function loginUser(email: string, password: string) {
  return async (dispatch: Dispatch) => {
    if (!!email && !!password) {
      dispatch({ type: SIGNIN_CALL })
      try {
        const signIn = await login({
          email,
          password
        })

        const status = signIn.status
        const token = signIn.data.token

        if (token && status === 200) {
          dispatch({ type: SIGNIN_SUCCESS, payload: { token } })

          return token
        }
      } catch (err) {
        dispatch({ type: SIGNIN_FAILURE, payload: { error: "error" } })
      }
    }
  }
}

export function checkUserToken() {
  return (dispatch: Dispatch) => {
    const token = localStorage.getItem("token")

    if (token) {
      dispatch({ type: AUTHENTICATION_CHECK_SUCCESS })
    } else {
      dispatch({ type: AUTHENTICATION_CHECK_ERROR })
    }
  }
}

export function signOut(navigate: NavigateFunction) {
  return (dispatch: Dispatch) => {
    localStorage.removeItem("token")
    dispatch({ type: SIGN_OUT_SUCCESS })
    navigate("/login")
  }
}
